import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d48b7c2")

_pushScopeId("data-v-5d48b7c2")
const _hoisted_1 = { class: "ui-search" }
const _hoisted_2 = {
  key: 0,
  class: "ui-search__body"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _directive_click_outside_element = _resolveDirective("click-outside-element")

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui-search__input",
      onClick: _cache[2] || (_cache[2] = (...args) => ($setup.onFocus(...args)))
    }, [
      _createVNode("input", {
        type: "text",
        value: $props.modelValue,
        disabled: $props.disabled,
        onInput: _cache[1] || (_cache[1] = (...args) => ($setup.input(...args)))
      }, null, 40, ["value", "disabled"]),
      _createVNode(_component_svg_icon, { name: $props.icon }, null, 8, ["name"])
    ]),
    ($setup.focus)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.options, (option, optionInd) => {
            return (_openBlock(), _createBlock("div", {
              key: optionInd,
              class: "ui-search__item",
              onClickCapture: $event => ($setup.clickOption(option))
            }, _toDisplayString($props.field(option)), 41, ["onClickCapture"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside_element, $setup.onBlur]
  ])
})